import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import WebScrapperOverview from './WebScrapperOverview';
import WebScrapperUploadFile from './WebScrapperUploadFile';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import './WebScraper.scss';

function TabPanel(props: {
  children?: React.ReactNode;
  value: number;
  index: number;
  [key: string]: unknown;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
      style={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        display: value === index ? 'flex' : 'none',
      }}
    >
      {value === index && (
        <Box
          p={2}
          sx={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

export default function WebScraper() {
  const location = useLocation();
  const initialTab = new URLSearchParams(location.search).get('tab') === 'monitor' ? 1 : 0;
  const [value, setValue] = React.useState(initialTab);

  return (
    <Box className="ws-container" id="web-scraper-container">
      <div className="ws-tab-wrapper">
        <Tabs
          value={value}
          onChange={(_e, v) => setValue(v)}
          id="web-scraper-tabs"
          aria-label="Web scraper navigation"
        >
          <Tab
            icon={<CloudUploadIcon fontSize="small" />}
            iconPosition="start"
            label="Upload & start"
            id="web-scraper-upload-tab"
            aria-controls="web-scraper-upload-panel"
          />
          <Tab
            icon={<QueryStatsIcon fontSize="small" />}
            iconPosition="start"
            label="Job monitor"
            id="web-scraper-monitor-tab"
            aria-controls="web-scraper-monitor-panel"
          />
        </Tabs>
      </div>

      <TabPanel value={value} index={0} id="web-scraper-upload-panel">
        <WebScrapperUploadFile onJobStarted={() => setValue(1)} />
      </TabPanel>
      <TabPanel value={value} index={1} id="web-scraper-monitor-panel">
        <WebScrapperOverview />
      </TabPanel>
    </Box>
  );
}
